module.exports = __webpack_public_path__ + "img/4_AR.b00c8d48.png";